import { render, staticRenderFns } from "./ShopsTablePage.vue?vue&type=template&id=d64d303a"
import script from "./ShopsTablePage.vue?vue&type=script&lang=js"
export * from "./ShopsTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports